// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Person } from "../../../data/app-core/person";
import { OrganizationalUnitPerson } from "../../../data/app-core/organizational-unit-person";
import { GroupPerson } from "../../../data/app-core/group-person";
import { SitePreferencesSet } from "../../../data/app-core/site-preferences-set";
import { SearchPreference } from "../../../data/app-core/search-preference";
import { EnvelopeDocument } from "../base/envelope-document";

export class PersonDocument extends EnvelopeDocument {
	public override Item: Person = new Person();
	public OrganizationalUnits: OrganizationalUnitPerson[] = [];
	public Groups: GroupPerson[] = [];
	public SitePreferencesSet: SitePreferencesSet = new SitePreferencesSet();
	public SearchPreferences: SearchPreference[] = [];
}